import type { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

// Ensures consistency in the edition attribute name and value
export const editionAnalytics = (
	edition: ConfluenceEdition | null,
): Record<'currentProductEdition', string | undefined> => ({
	currentProductEdition: edition?.toLowerCase(),
});
